(function(){
var Q=window.MHTQA;if(!Q||Q.ship)return;
Q.ship=function(){var el=document.querySelector('.mhtqa-ship'),sub=document.querySelector('.mhtqa-sub b');if(!el&&!sub)return;
fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
if(sub)sub.textContent=(c.total_price/100).toLocaleString('fr-FR')+' FCFA';
if(!el)return;
var t=Math.round(c.total_price/100),A=20000,B=30000,txt,pct,ok=false;
if(t>=B){ok=true;txt='\uD83C\uDF89 Bravo, LIVRAISON GRATUITE partout en C\u00f4te d\u2019Ivoire !';pct=100;}
else if(t>=A){ok=true;txt='\uD83C\uDF89 LIVRAISON GRATUITE \u00e0 Abidjan ! Plus que '+(B-t).toLocaleString('fr-FR')+' FCFA pour la gratuit\u00e9 partout';pct=Math.round(t/B*100);}
else{txt='\uD83D\uDE9A Plus que '+(A-t).toLocaleString('fr-FR')+' FCFA pour la LIVRAISON GRATUITE \u00e0 Abidjan';pct=Math.round(t/A*100);}
el.className='mhtqa-ship'+(ok?' ok':'');
el.innerHTML='<div class="mhtqa-shiptxt"></div><div class="mhtqa-shiptrack"><div class="mhtqa-shipfill"></div></div>';
el.querySelector('.mhtqa-shiptxt').textContent=txt;el.querySelector('.mhtqa-shipfill').style.width=pct+'%';
}).catch(function(){});};
})();